import { FC, useMemo, useState } from "react";
import { SEND_PROJECT_TABS } from "../SendProjectModal";
import { SlideNavigation } from "shared/components/slideNavigation";
import { FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst } from "core";
import { useTheme } from "styled-components";
import { DropdownTabs } from "shared/pages/exploreHseContextsNew/components/DropdownTabs";
import { useTranslation } from "react-i18next";

export const SendProjectsTabs: FC<{ 
    tab: SEND_PROJECT_TABS, 
    onTabChange: (s: SEND_PROJECT_TABS) => void 
}> = ({ tab, onTabChange}) => {
    const isTab = useIsMobile();
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useBreakpoint(LayoutConst.screen.s-1)
    const navItems = useMemo(() => (
        {...Object.values(SEND_PROJECT_TABS)?.reduce((a, v) => ({ ...a, [v]: t(`tab_names.competition_tabs.${v}`).toLowerCase()}), {})}
    ), [t])
  
     return (
      <FlexBox offsetTopMobile={isMobile ? 8 : 0}>
        {!isTab ? (
          <SlideNavigation
            activeIndexKey={tab}
            onChange={onTabChange}
            items={navItems}
            isDropdown
            autoWidth
            isLoading={false}
            whiteTheme={false}
            isCompetition={true}
          /> 
        ) : (
         <>
            <DropdownTabs
              customTitleTheme={theme as any}
              whiteTheme={false}
              activeTabKey={tab}
              isShort={true}
              items={navItems}
              onChange={onTabChange}
            />
         </>
        )}
      </FlexBox>
    )
}import { FC, useMemo, useState } from "react";
import { SEND_PROJECT_TABS } from "../SendProjectModal";
import { SlideNavigation } from "shared/components/slideNavigation";
import { FlexBox, useBreakpoint, useIsMobile } from "@brg/ui";
import { LayoutConst } from "core";
import { useTheme } from "styled-components";
import { DropdownTabs } from "shared/pages/exploreHseContextsNew/components/DropdownTabs";
import { useTranslation } from "react-i18next";

export const SendProjectsTabs: FC<{ 
    tab: SEND_PROJECT_TABS, 
    onTabChange: (s: SEND_PROJECT_TABS) => void 
}> = ({ tab, onTabChange}) => {
    const isTab = useIsMobile();
    const theme = useTheme();
    const { t } = useTranslation();
    const isMobile = useBreakpoint(LayoutConst.screen.s-1)
    const navItems = useMemo(() => (
        {...Object.values(SEND_PROJECT_TABS)?.reduce((a, v) => ({ ...a, [v]: t(`tab_names.competition_tabs.${v}`).toLowerCase()}), {})}
    ), [t])
  
     return (
      <FlexBox offsetTopMobile={isMobile ? 8 : 0}>
        {!isTab ? (
          <SlideNavigation
            activeIndexKey={tab}
            onChange={onTabChange}
            items={navItems}
            isDropdown
            autoWidth
            isLoading={false}
            whiteTheme={false}
            isCompetition={true}
          /> 
        ) : (
         <>
            <DropdownTabs
              customTitleTheme={theme as any}
              whiteTheme={false}
              activeTabKey={tab}
              isShort={true}
              items={navItems}
              onChange={onTabChange}
            />
         </>
        )}
      </FlexBox>
    )
}